import React from "react";
import "./AboutUs.css";
import placeholder from "../../assets//image 3.png";
import logo from "../../assets//Logo_m.png";
// import Partner from "../../components/partner/partner";


function AboutUs() {
  return (
    <>
      <section className="purpose-section">
        <div className="container">
          <div className="section-header">
            <h2 className="sub-heading section-heading ">เกี่ยวกับสมาคม</h2>
          </div>

          <h3 className="section-subtitle green">วัตถุประสงค์ของสมาคมฯ</h3>
          <ol className="about-list">
            <li>
              เป็นศูนย์กลางแลกเปลี่ยนความรู้ ประสบการณ์ ความคิดเห็น
              ระหว่างสมาชิก และส่งเสริมการเผยแพร่ข้อมูล
            </li>
            <li>นำอาชีพที่เป็นประโยชน์ต่อการศึกษาและวัฒนธรรม</li>
            <li>
              ดำเนินงานและคุ้มครองผลประโยชน์ของสมาชิกซึ่งปฏิบัติหน้าที่โดยชอบ
            </li>
            <li>
              ส่งเสริมด้านจริยธรรมและพัฒนาเว็บ
              และยกระดับสมาชิกของสมาคมให้สูงขึ้น
            </li>
            <li>
              เป็นศูนย์กลางประสานงานให้เกิดผลลัพธ์ไม่ซ้ำกันในปัญหาของสังคมสาธารณกุศล
            </li>
            <li>
              มุ่งยึดมั่นมาตรฐานอันดีงามและการพัฒนาของสมาชิกให้เป็นไปตามจรรยาบรรณแห่งวิชาชีพ
            </li>
            <li>
              ส่งเสริมงานสานสมัคคี กิจกรรม และกิจกรรมสาธารณะกุศลแก่ผู้สนับสนุน
            </li>
          </ol>
          <div className="image-grid">
            <img src={placeholder} alt="placeholder" />
            <img src={placeholder} alt="placeholder" />
          </div>
        </div>
      </section>

      <section className="history-section">
        <div className="container ">
          <h3 className="section-subtitle green">แนวคิดการจัดตั้งสมาคม</h3>
          <div className="gride ">
            <p className="about-paragraph">
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;การจัดตั้งสมาคมนวัตกรรมสิ่งแวดล้อม เป็นการรวมพลังจากผู้เชี่ยวชาญ นักวิจัย นักอุตสาหกรรม และผู้บริหารองค์กรที่มีความมุ่งมั่นในการผลักดันประเทศไทยสู่ เศรษฐกิจสีเขียว (Green Economy) และ สังคมคาร์บอนต่ำ (Low Carbon Society)
“สมาคมฯ จะทำหน้าที่เป็น กลไกเชื่อมโยง (Connector) และ แพลตฟอร์มความร่วมมือ (Collaborative Platform) ระหว่างภาครัฐ เอกชน สถาบันการศึกษา ชุมชน และองค์กรระหว่างประเทศ เพื่อให้เกิดการเปลี่ยนผ่านด้านสิ่งแวดล้อมอย่างเป็นระบบและยั่งยืน”
<br></br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;โดยมีนโยบายและทิศทางการดำเนินงานใน 6 ด้านหลัก ได้แก่<br></br>
<b>ด้านที่ 1 </b>ความร่วมมือกับภาครัฐ  <b>โดยมีเป้าหมาย</b> เสริมบทบาทสมาคมในฐานะกลไกสนับสนุนนโยบายรัฐด้านการพัฒนามาตรฐานอุตสาหกรรม สิ่งแวดล้อม และพลังงานสะอาด<br></br>
<b>ด้านที่ 2 </b>ความร่วมมือกับภาคเอกชนและอุตสาหกรรม <b>โดยมีเป้าหมาย</b> ส่งเสริมการพัฒนาอุตสาหกรรมและความร่วมมือภาคเอกชน <br></br>
<b>ด้านที่ 3 </b>ความร่วมมือกับสถาบันการศึกษาและวิจัย <b>โดยมีเป้าหมาย</b> พัฒนาองค์ความรู้ วิจัย นวัตกรรม และระบบฐานข้อมูลระดับประเทศ <br></br>
<b>ด้านที่ 4 </b>ความร่วมมือกับชุมชนและสังคม <b>โดยมีเป้าหมาย</b> สร้างจิตสำนึก ความร่วมมือกับชุมชนและสังคม<br></br>
<b>ด้านที่ 5 </b>ความร่วมมือระหว่างประเทศ <b>โดยมีเป้าหมาย</b> ขยายเครือข่ายความร่วมมือสู่ระดับภูมิภาคและโลก<br></br>
<b>ด้านที่ 6 </b>ความร่วมมือด้านเทคโนโลยีและนวัตกรรม <b>โดยมีเป้าหมาย</b> สร้าง “ศูนย์กลางเทคโนโลยีและข้อมูลสิ่งแวดล้อมของประเทศ” <br></br>             
            </p>
            <div className="ima">
              <img src={logo} alt="logo" />
            </div>
          </div>
        </div>
      </section>
      {/* <Partner /> */}
    </>
  );
}

export default AboutUs;
